import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  RESET_DAILY_VISIT,
} from "../../actionTypes";

export const fetchDashboardDataRequest = (data) => ({
  type: FETCH_DASHBOARD_DATA_REQUEST,
  payload: data
});

export const fetchDashboardDataSuccess = (data) => ({
  type: FETCH_DASHBOARD_DATA_SUCCESS,
  payload: data,
});

export const fetchDashboardDataFailure = (error) => ({
  type: FETCH_DASHBOARD_DATA_FAILURE,
  payload: error,
});

export const resetDailyVisit = () => ({
  type: RESET_DAILY_VISIT,
});
